if (typeof window === 'undefined') {

    facebookAdsInsights(
        module.exports,
        require('./socialPosts.js'),
        require('./dimensions.js'),
        require('./aggregates.js'),
        require('./expansions.js'),
        require('../../utils/timePeriod.js'),
        require('lodash'),
        require('../../../../lib/riq-moment.js')
    );

} else {

    facebookAdsInsights(
        RivalIQ.models.metrics,
        RivalIQ.models.metrics,
        RivalIQ.models.metrics,
        RivalIQ.models.metrics,
        RivalIQ.models.metrics.expansions,
        RivalIQ.utils.timePeriod,
        window._,
        window.moment
    );
}


function facebookAdsInsights(metrics, socialPostsMetrics, dimensions, aggregates, expansions, timePeriodUtils, _, moment) {

    'use strict';

    function getModels() {
        return (typeof window === 'undefined' ? require('../metric.js') : RivalIQ.models);
    }

    const FbAdsInsightsMetric = {
        build: function () {
            const me = this;
            const definition = socialPostsMetrics.getMetricBase().build.apply(me, arguments);
            definition.data = me.data;
            return definition;
        },

        fetch: function (attrs) {
            const me = this;

            attrs = _.extend(me.resolvedAttributes(), attrs);
            return _.result(me, 'metricsCollection')
                .fetch(attrs)
                .then(function (data) {
                    const attributes = _.extend({}, me.resolvedAttributes());
                    const models = getModels();

                    const metric = new models.Metric(attributes, data);
                    metric.unexpandedAttributes = me.unexpandedAttributes;
                    return metric;
                });
        },

        getOrderBy: function () {
            const me = this;
            return me.get('property');
        },

        serialize: function () {
            const me = this;
            return me.toJSON();
        }
    };

    metrics.FbAdObjects = _.extend({}, socialPostsMetrics.getMetricBase(), FbAdsInsightsMetric, {

        metricsCollection: function () {
            return RivalIQ.apps.AdsInsights.data.fbAdObjects;
        },

        getSubmetricValue: function (property, submetric) {
            if (property === 'adObject') {
                return submetric;
            }
        },

        expandSparseDayValues: function (value) {
            const me = this;

            const sparseValues = _.keyBy(value, function (dayValue) {
                return Number(_.head(dayValue));
            });

            const timePeriod = me.get('timePeriod');
            const numDaysInPeriod = timePeriodUtils.getPeriodCount(moment.utc(timePeriod.mainPeriodStart), moment.utc(timePeriod.mainPeriodEnd));

            return _.map(_.range(numDaysInPeriod), function (idx) {
                const dailyValue = _.last(sparseValues[idx]);
                return [idx, (_.isUndefined(dailyValue) ? null : Number(dailyValue))];
            });
        },

        getValue: function (options) {
            const me = this;
            if (_.get(options, 'format') === 'csv') {
                options.rawValue = true;
            }

            if (_.get(options, 'rawValue')) {
                options.format = false;
            }

            let value = socialPostsMetrics.getMetricBase().getValue.apply(me, arguments);

            if (_.get(options, 'rawValue')) {
                if (_.isArray(_.head(value))) {
                    value = _.map(value, function (singleValuePair) {
                        const singleValue = _.last(singleValuePair);
                        singleValuePair[singleValuePair.length - 1] = _.isObject(singleValue) ? singleValue.value : singleValue;
                        return singleValuePair;
                    });
                } else {
                    value = _.get(value, 'value', value);
                }
            }

            if (_.includes(me.get('dimensions'), 'day')) {
                return me.expandSparseDayValues(value);
            }

            return value;
        },

        formatExpanded: function (data) {
            const me = this;

            let value;

            // this is a little hacky; the formatter for currency needs the full object (value + metadata), while
            // other formatters just want the numeric value.
            if (RivalIQ.metric.property.type(me.attributes) !== RivalIQ.enums.dataType.CURRENCY) {
                value = RivalIQ.metric.data.rawValue(me.attributes, data);
            } else {
                value = _.last(data);
            }

            if (_.isUndefined(value)) {
                return '--';
            }

            return RivalIQ.metric.format.expandedFormatFn(me.attributes, data, {
                expanded: true
            })(value);
        }
    });
}
